var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item",class:{
    'menu-item-submenu': _vm.menu.submenu,
    'menu-item-open': _vm.activeMenu(_vm.menu)
  },attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('KTMenuItemText',{attrs:{"menu":_vm.menu},on:{"click":function($event){return _vm.$emit('click')}}}),(_vm.menu.submenu)?_c('KTMenuSubmenu',{attrs:{"submenu":_vm.menu.submenu,"parentMenu":_vm.menu}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }